import { makeObservable, observable, action } from "mobx";
import PartnerAnalyticsDashboardAPI from "../api/PartnerAnalyticsDashboardAPI";
import {
  PartnerAnalyticsChartData,
  StatusWiseShipmentsCount,
} from "../../../models/Dashboard/PartnerDashboard/PartnerAnalytics";
import { PartnerAnalyticsAPIFilters } from "../../../models/Dashboard/PartnerDashboard/PartnerAnalyticsFilters";
import {
  ShipmentStatus,
  ShipmentStatusFilter,
} from "../../../models/Shipments/ShipmentStatus";
import allShipment from "../../../assets/allShipment.png";
import dayjs from "dayjs";
import { GetShipmentsParams } from "./ShipmentStore";
import { PaginatedAPIResponse } from "../../../models/NetworkResponse";
import { Shipments } from "../../../models/Shipments";

export class PartnerAnalyticsDashboardStore {
  analyticsAPI: PartnerAnalyticsDashboardAPI;
  response: PartnerAnalyticsChartData | null;
  statusFilters: ShipmentStatusFilter[];
  shipmentsReponse: PaginatedAPIResponse<Shipments>;

  constructor() {
    this.analyticsAPI = new PartnerAnalyticsDashboardAPI();
    this.response = {} as PartnerAnalyticsChartData;
    this.shipmentsReponse = {} as PaginatedAPIResponse<Shipments>;
    this.statusFilters = [];

    makeObservable(this, {
      response: observable,
      statusFilters: observable,
      shipmentsReponse: observable,
      getShipmentsChartData: action,
      getShipments: action,
    });
  }

  setShipmentFilters = (list: StatusWiseShipmentsCount[] | null) => {
    this.statusFilters = [];

    const total_count =
      list?.reduce((sum, item) => sum + item.requests_count, 0) || 0;

    const shipment_status_map = new Map<
      number,
      { id: number; value: string; icon: string }
    >();

    ShipmentStatus.forEach((element) => {
      shipment_status_map.set(element.id, element);
    });

    this.statusFilters.push({
      id: 0,
      count: total_count,
      label: "All Shipments",
      icon: allShipment,
    });

    if (!list) {
      shipment_status_map.forEach((value, key) => {
        this.statusFilters.push({
          id: key,
          count: 0,
          label: value.value,
          icon: value.icon,
        });
      });
      return;
    }

    list.forEach((item) => {
      this.statusFilters.push({
        id: item.status,
        count: item.requests_count,
        label: shipment_status_map.get(item.status)?.value || "-",
        icon: shipment_status_map.get(item.status)?.icon || "",
      });
    });
  };

  getShipmentsChartData = async (filters: PartnerAnalyticsAPIFilters) => {
    try {
      filters.start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      filters.end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const res = await this.analyticsAPI.getShipmentsChartData(filters);
      this.response = res;
      this.setShipmentFilters(res.status_wise_shipments_count);
    } catch (error) {
      console.error("Error fetching pack label-wise quantity:", error);
    }
  };

  getShipments = async (params: GetShipmentsParams = {}) => {
    try {
      this.shipmentsReponse = await this.analyticsAPI.getShipments(params);
    } catch (error: any) {
      console.error("Error fetching shipments:", error);
    }
  };
}
